module.exports = __webpack_public_path__ + "images/34c687eafc9a3fbade3096ff8348a543.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/logo.png
// module id = 1921
// module chunks = 0